import { useInvalidateOrganization } from "@/hooks/use-invalidate-organization";
import { OrganizationTeam } from "@/components/orgs/organization-team";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/organization/members")({
  component: RouteComponent,
  head: () => ({ meta: [{ title: "Papier - Team members" }] }),
});
function RouteComponent() {
  const invalidateOrganization = useInvalidateOrganization();
  return <OrganizationTeam onLeaveSuccess={invalidateOrganization} />;
}
